import { useEffect } from 'react';
import { AlertCircle, Check, Users } from 'lucide-react';

// Failure copy across the app starts with these; everything else is a confirmation.
const FAILURE = /^(failed|could not|couldn't|unable|error|something went wrong|no connection)/i;

/**
 * A toast in the app's glass (operator, 2026-09-23: the old solid purple slab looked "old ... very static"):
 * the frosted pill the search bars use, a lavender ring, a small icon, a soft rise-in. Tap to dismiss.
 */
export default function Toast({ message, onClose, duration = 4000, action = null }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const failed = FAILURE.test(String(message || '').trim());
  const Icon = failed ? AlertCircle : action ? Users : Check;

  // With an action the toast is a prompt, not a confirmation: the Join icon, and the button beside the line. A tap on
  // the line still dismisses it.
  if (action) {
    return (
      <div role="status" aria-live="polite" className="app-toast app-toast--action">
        <button type="button" className="app-toast__dismiss" onClick={onClose}>
          <span className="app-toast__icon" aria-hidden="true">
            <Icon size={15} strokeWidth={2.4} />
          </span>
          <span className="app-toast__text">{message}</span>
        </button>
        <button
          type="button"
          className="app-toast__action"
          onClick={() => {
            onClose();
            action.onClick?.();
          }}
        >
          {action.label}
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onClose}
      role="status"
      aria-live="polite"
      className={`app-toast${failed ? ' app-toast--failed' : ''}`}
    >
      <span className="app-toast__icon" aria-hidden="true">
        <Icon size={15} strokeWidth={2.4} />
      </span>
      <span className="app-toast__text">{message}</span>
    </button>
  );
}
